import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormLabel,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { memo } from "react";

const MEDICAL_ROLES = ["MO", "DEO", "STAFF_NURSE"];

const SubcenterSection = ({
  districts,
  talukas,
  villages,
  user,
  selectedDistrict,
  selectedTaluka,
  selectedPHC,
  selectedSubcenter,
  selectedVillage,
  formData,
  handleChange,
  handleVillageChange,
  handleSubcenterChange,
  handleTalukaChange,
  handlePHCChange,
  phcs,
  subcenters,
  subusers,
  ashas,
  formDetails,
  formErrors,
  villageRef,
  familyInfo
}) => {
  const isEditable = MEDICAL_ROLES.includes(user?.rolename);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
      },
    },
  };

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{
        backgroundColor: "#f5f5f5",
        fontWeight: 600,
        border: "1px solid #e0e0e0",
      }}>
        <Typography variant="h6">Subcenter Information</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ overflow: 'visible' }}>
        <Grid container spacing={4} sx={{ p: 2 }}>
          {/* District Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/district.png"}
                alt="district"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                  District <span style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}>*</span>
                </FormLabel>
                <Select
                  disabled={true}
                  value={selectedDistrict || ""}
                  size="small"
                  fullWidth
                  MenuProps={MenuProps}
                >
                  {isEditable ? (
                    districts?.length > 0 ? (
                      districts.map((district) => (
                        <MenuItem
                          key={district.locationId}
                          value={district.locationId}
                        >
                          {district.locationName}
                        </MenuItem>
                      ))
                    ) : selectedDistrict && formDetails?.locationHierarchy ? (
                      <MenuItem value={selectedDistrict}>
                        {formDetails.locationHierarchy.districtName}
                      </MenuItem>
                    ) : (
                      <MenuItem value="">No districts available</MenuItem>
                    )
                  ) : (
                    <MenuItem value={formDetails?.districtId || ""}>
                      {formDetails?.district || ""}
                    </MenuItem>
                  )}
                </Select>
              </Box>
            </Box>
          </Grid>

          {/* Block / Taluk Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/block.png"}
                alt="block"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                  Block / Taluk Name <span style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}>*</span>
                </FormLabel>

                <Select
                  disabled={true}
                  value={selectedTaluka ? String(selectedTaluka) : ""}
                  onChange={handleTalukaChange}
                  size="small"
                  fullWidth
                  MenuProps={MenuProps}
                >
                  {isEditable ? (
                    talukas?.length > 0 ? (
                      <>
                        <MenuItem value="">-Select Block/Taluk-</MenuItem>
                        {talukas.map((taluka) => (
                          <MenuItem
                            key={taluka.locationId}
                            value={String(taluka.locationId)}
                          >
                            {taluka.locationName}
                          </MenuItem>
                        ))}
                      </>
                    ) : selectedTaluka && formDetails?.locationHierarchy ? (
                      <MenuItem value={selectedTaluka}>
                        {formDetails.locationHierarchy.talukaName}
                      </MenuItem>
                    ) : selectedTaluka && familyInfo.addressInfo?.talukaId ? (

                      <MenuItem value={selectedTaluka}>
                        {familyInfo.addressInfo.taluka}
                      </MenuItem>

                    ) : (
                      <MenuItem value="">
                        {user?.rolename === "STAFF_NURSE"
                          ? "-Select Block/Taluk-"
                          : "No talukas available"}
                      </MenuItem>
                    )
                  ) : (
                    <MenuItem value={formDetails?.talukaId || ""}>
                      {formDetails?.taluka || ""}
                    </MenuItem>
                  )}
                </Select>
              </Box>
            </Box>
          </Grid>

          {/* PHC Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/phc.png"}
                alt="phc"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                  PHC <span style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}>*</span>
                </FormLabel>

                <Select
                  disabled={true}
                  value={String(selectedPHC || "")}
                  onChange={handlePHCChange}
                  size="small"
                  fullWidth
                  MenuProps={MenuProps}
                >
                  <MenuItem value="">-Select PHC-</MenuItem>

                  {phcs?.length > 0 ? (
                    phcs.map((phc) => (
                      <MenuItem key={phc.locationId} value={String(phc.locationId)}>
                        {phc.locationName}
                      </MenuItem>
                    ))
                  ) : formDetails?.phcId ? (
                    <MenuItem value={String(formDetails.phcId)}>
                      {formDetails.phc}
                    </MenuItem>
                  ) : null}
                </Select>
              </Box>
            </Box>
          </Grid>


          {/* Sub center Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/subcenter.png"}
                alt="subcenter"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                  Sub center <span style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}>*</span>
                </FormLabel>
                <Select
                  disabled={true}
                  value={String(isEditable ? selectedSubcenter || "" : user?.facility || "")}
                  onChange={handleSubcenterChange}
                  size="small"
                  fullWidth
                  MenuProps={MenuProps}
                >
                  <MenuItem value="">-Select Sub center-</MenuItem>
                  {subcenters?.length > 0 ? (
                    subcenters.map((subcenter) => (
                      <MenuItem
                        key={subcenter.locationId}
                        value={String(subcenter.locationId)}
                      >
                        {subcenter.locationName}
                      </MenuItem>
                    ))
                  ) : user?.facility ? (
                    <MenuItem value={String(user.facility)}>
                      {user.facilityName}
                    </MenuItem>
                  ) : null}
                </Select>
              </Box>
            </Box>
          </Grid>

          {/* Name of Village Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }} ref={villageRef}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/village.png"}
                alt="village"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                  Name of Village <span style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}>*</span>
                </FormLabel>
                <>
                  <Select
                    name="familyInfo.addressInfo.villageId"
                    value={formData.familyInfo.addressInfo.villageId || ""}
                    onChange={handleVillageChange}
                    error={Boolean(formErrors?.villageId)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    MenuProps={MenuProps}>

                    <MenuItem value="">-Select Village-</MenuItem>
                    {villages?.length > 0 &&
                      villages.map((village) => {
                        const villageId = village.locationId || village.id || village.villageId;
                        const villageName = village.locationName || village.name || village.villageName;
                        return (
                          <MenuItem
                            key={villageId}
                            value={villageId}
                          >
                            {villageName}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {formErrors.villageId && (
                    <Typography
                      variant="caption"
                      sx={{ color: "error.main", display: "block", mt: 0.5 }}
                    >
                      {formErrors.villageId}
                    </Typography>
                  )}
                </>
              </Box>
            </Box>
          </Grid>

          {/* Other Village Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/village.png"}
                alt="other-village"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                  Other Village {formData.familyInfo.addressInfo.village === "Other" && (<span style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}>*</span>)}
                </FormLabel>
                <TextField
                  fullWidth
                  size="small"
                  name="familyInfo.addressInfo.villageOther"
                  value={formData.familyInfo.addressInfo.villageOther}
                  disabled={formData.familyInfo.addressInfo.village !== "Other"}
                  onChange={handleChange}
                  error={Boolean(formErrors?.villageOther)}
                  helperText={formErrors?.villageOther}
                  variant="outlined"
                  placeholder="Enter village name" />
              </Box>
            </Box>
          </Grid>

          {/* Name of Subcenter User Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/ANMEnr.png"}
                alt="ANM"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                  Name of Subcenter User
                </FormLabel>
                <Select
                  name="individualInfo.additionalDetails.anmName"
                  value={
                    formData.individualInfo.additionalDetails.anmName || ""
                  }
                  onChange={handleChange}
                  disabled={subusers?.length === 0 ? !isEditable : false}
                  size="small"
                  fullWidth
                  MenuProps={MenuProps}>
                  <MenuItem value="">-Select Subcenter User-</MenuItem>
                  {subusers?.length > 0 &&
                    subusers.map((center) => (
                      <MenuItem
                        key={center.username || center.id}
                        value={center.username || center.id}
                      >
                        {center.username || center.id} {center.name ? `(${center.name})` : ""}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            </Box>
          </Grid>

          {/* Name of ASHA Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/asha.png"}
                alt="asha"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}>
                  Name of ASHA
                </FormLabel>
                <Select
                  name="familyInfo.additionalDetails.ASHA"
                  value={
                    formData.familyInfo.additionalDetails.ASHA || ""
                  }
                  onChange={handleChange}
                  size="small"
                  fullWidth
                  MenuProps={MenuProps}>
                  <MenuItem value="">Select</MenuItem>
                  {ashas?.length > 0 &&
                    ashas.map((asha) => {
                      const ashaId = asha.ID || asha.id;
                      const ashaName = asha.name || ashaId;
                      return (
                        <MenuItem key={ashaId} value={ashaId}>
                          {ashaName}
                        </MenuItem>
                      );
                    })}
                </Select>
              </Box>
            </Box>
          </Grid>

          {/* Hamlet Name Field */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              <img
                src={"/images/hamlet.png"}
                alt="hamlet"
                style={{ width: "50px", height: "50px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1 }}>
                <FormLabel sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#333", display: "block" }}>
                  Hamlet Name
                </FormLabel>
                <TextField
                  fullWidth
                  size="small"
                  name="familyInfo.additionalDetails.hamlet"
                  value={formData.familyInfo.additionalDetails.hamlet || ""}
                  onChange={handleChange}
                  variant="outlined"
                  placeholder="Enter hamlet name" />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default memo(SubcenterSection);
